const MuiInputAdornment = {
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 0
    }
  }
};
export default MuiInputAdornment;